import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import Accordion from 'react-bootstrap/Accordion';
import KTRadio, { KTRadioType } from '../KTFormControls/KTRadio';
import './style.scss';

KTFolderTreeView.propTypes = {
  children: PropTypes.array,
  defaultOpenedFolderId: PropTypes.string,
  selectedValue: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  isVehicleBrandTree: PropTypes.bool,
  handleCloseDropdown: PropTypes.func,
};

KTFolderTreeView.defaultProps = {
  children: [],
  defaultOpenedFolderId: '',
};

/**
 *
 * @param {{
 * children: {id: string, name: string, children: []}[],
 * defaultOpenedFolderId: string,
 * }} props
 * @returns
 */
function KTFolderTreeView(props) {
  // ---- Params -----
  const { children, selectedValue, onSelect, openedBrands } = props;

  return (
    <div className="KTFolderTreeView">
      <Accordion alwaysOpen defaultActiveKey={openedBrands}>
        {children.map((item, index) => {
          return (
            <Accordion.Item key={index} eventKey={item.id} className="border-0">
              <Accordion.Header
                className={`${item.children ? '' : 'model'} py-4 px-5`}
                onClick={(e) => {
                  if (!item.children) {
                    e.stopPropagation();
                    if (selectedValue !== item.name) {
                      onSelect(item.name);
                    }
                  }
                }}
              >
                <div className={`d-flex align-items-center w-100`}>
                  {item.type && (
                    <span className="w-60px">
                      {item.image && item.type === 'brand' && (
                        <img
                          className="h-25px w-30px ml-4"
                          src={Utils.getFullUrl(item.image)}
                          style={{
                            objectFit: 'cover',
                            width: 33,
                          }}
                        />
                      )}
                      {item.image && item.type === 'model' && (
                        <img
                          className="h-35px w-50px ml-3"
                          src={Utils.getFullUrl(item.image)}
                          style={{
                            objectFit: 'cover',
                            borderRadius: 5,
                          }}
                        />
                      )}
                    </span>
                  )}
                  <p className="m-0 flex-grow-1 px-2">{item.name}</p>
                  {!(item.type === 'brand') && (
                    <KTRadio
                      name={item.name}
                      checked={selectedValue === item.name}
                      type={KTRadioType.outline}
                      onChange={() => {
                        onSelect(item.name);
                      }}
                    />
                  )}
                </div>
              </Accordion.Header>

              <Accordion.Body className="pl-6 pr-0 py-0">
                {item?.children && _.isArray(item?.children) && (
                  <KTFolderTreeView
                    children={item?.children}
                    selectedValue={selectedValue}
                    onSelect={onSelect}
                  />
                )}
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </div>
  );
}

export default KTFolderTreeView;
